import { DialogRef } from '@angular/cdk/dialog';

import { Component, inject, Input, OnDestroy, OnInit, signal, input, output } from '@angular/core';
import { BmiStore } from '@bmi-store';
import { Bmi } from '@types-lib';
import { DefaultDialogService } from '@ui-lib/services';
import { Subject, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { BiometricsDisplayComponent } from './biometrics-display/biometrics-display.component';
import { BMIDialogComponent } from './biometrics-logs-dialog/biometrics-logs-dialog.component';

@Component({
  selector: 'biometrics-container',
  imports: [BiometricsDisplayComponent],
  templateUrl: './biometrics-container.component.html',
  styleUrl: './biometrics-container.component.scss',
})
export class BiometricsContainerComponent implements OnInit, OnDestroy {
  @Input({ required: true }) patientId!: number;
  readonly visitId = input<number>();
  readonly showLogsButton = input(true);
  readonly viewLogsClick = output<MouseEvent>();

  restartPolling = signal<boolean | null>(null);
  private dialog = inject(DefaultDialogService);
  private openBMIDialog$$ = new Subject<void>();
  private bmiDialogRef?: DialogRef<BMIDialogComponent, BMIDialogComponent>;
  readonly store = inject(BmiStore);
  subscriptions = new Subscription();

  ngOnInit(): void {
    this.store.loadBmiData({ userId: this.patientId, limit: 1 });

    this.subscriptions.add(
      this.openBMIDialog$$
        .pipe(
          filter(() => !this.dialog.hasOpenDialogsOfType(BMIDialogComponent)),
          tap(() => this.store.loadBmiData({ userId: this.patientId })),
        )
        .subscribe(() => {
          this.restartPolling.set(false);
          this.bmiDialogRef = this.dialog.open<BMIDialogComponent, Bmi.BMIDialogData>(BMIDialogComponent, {
            height: '576px',
            width: '1256px',
            data: {
              patientId: this.patientId,
              visitId: this.visitId(),
            },
          });
          this.subscriptions.add(
            this.bmiDialogRef.closed.subscribe(() => {
              this.restartPolling.set(true);
            }),
          );
        }),
    );
  }

  onViewLogsClick() {
    this.openBMIDialog$$.next();
  }

  ngOnDestroy(): void {
    this.bmiDialogRef?.close();
    this.subscriptions.unsubscribe();
    this.store.resetStoreToInitialState();
  }
}
